import { FacilityListParams } from '@gyym/sdk'

import {
  useCity,
  useFacilitiesMetaActivity,
  useFacilitiesMetaArea,
  useFacilitiesMetaPrefecture,
} from '@/modules/Facilities'
import { useTag } from '@/modules/Tags'

export const useSearchData = (searchParams: FacilityListParams) => {
  const {
    prefectureIds = [],
    activityIds = [],
    areaIds = [],
    tags = [],
    cityCode,
  } = searchParams

  const prefecture = useFacilitiesMetaPrefecture(
    prefectureIds.length === 1 && areaIds.length === 0
      ? prefectureIds[0]
      : undefined,
  )

  const activity = useFacilitiesMetaActivity(
    activityIds.length === 1 ? activityIds[0] : undefined,
  )

  const area = useFacilitiesMetaArea(
    areaIds.length === 1 && prefectureIds.length === 0 ? areaIds[0] : undefined,
  )

  const city = useCity(cityCode)

  const { data: tag } = useTag(tags.length === 1 ? tags[0] : undefined)

  return {
    prefecture,
    activity,
    area,
    city,
    tag,
  }
}
